module.exports = __webpack_public_path__ + "assets/img/custody-btc.ceb0c139.png";